import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Lock, Download, ShieldCheck, Zap } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { motion } from 'framer-motion';
const BOOK_COVER = 'https://cdn.magicpatterns.com/uploads/116EEuHnFcXbicz3box3HL/ChatGPT_Image_Mar_29,_2026,_05_17_27_PM.png';
export function Offer() {
  return <section id="oferta" className="w-full bg-night-950 text-white py-16 md:py-24 px-6 relative overflow-hidden" data-id="element-258">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-purple-900/20 rounded-full blur-[120px] pointer-events-none" data-id="element-259" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-260">
        <FadeIn data-id="element-261">
          <h2 className="text-3xl md:text-5xl font-serif text-center mb-10 md:mb-16" data-id="element-262">
            Esto es todo lo que obtienes hoy:
          </h2>
        </FadeIn>

        <FadeIn delay={0.05} data-id="element-263">
          <div className="flex justify-center mb-8 md:mb-12" data-id="element-264">
            <img src={BOOK_COVER} alt="Mente en Calma — Guía PDF" className="w-40 md:w-56 rounded-xl" style={{
            WebkitMaskImage: 'radial-gradient(ellipse 85% 85% at center, black 70%, transparent 100%)',
            maskImage: 'radial-gradient(ellipse 85% 85% at center, black 70%, transparent 100%)'
          }} data-id="element-265" />
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-266">
          <div className="bg-white/5 border border-white/10 rounded-3xl p-6 md:p-12 backdrop-blur-sm mb-12" data-id="element-267">
            <div className="space-y-3 md:space-y-4 mb-8" data-id="element-268">
              {[{
              icon: '📘',
              title: 'Guía Mente en Calma (PDF 36 páginas)',
              value: '$47'
            }, {
              icon: '🌙',
              title: 'Protocolo noche por noche (Noches 1–7)',
              value: '$27'
            }, {
              icon: '🛑',
              title: 'Protocolo especial despertar 3am',
              value: '$15'
            }, {
              icon: '📋',
              title: 'Checklist de cierre diario imprimible',
              value: '$9'
            }].map((item, i) => <div key={i} className="flex items-center justify-between py-3 md:py-4 border-b border-white/10 last:border-0" data-id="element-269">
                  <div className="flex items-center" data-id="element-270">
                    <span className="text-xl md:text-2xl mr-3 md:mr-4" data-id="element-271">
                      {item.icon}
                    </span>
                    <span className="text-sm md:text-lg text-slate-200 pr-2" data-id="element-272">
                      {item.title}
                    </span>
                  </div>
                  <span className="text-sm md:text-base text-slate-400 font-medium whitespace-nowrap" data-id="element-273">
                    {item.value}
                  </span>
                </div>)}
            </div>

            <div className="flex justify-between items-center py-5 md:py-6 border-t-2 border-white/20 mb-8" data-id="element-274">
              <span className="text-lg md:text-xl font-bold" data-id="element-275">
                TOTAL VALOR REAL
              </span>
              <span className="text-lg md:text-xl font-bold line-through text-slate-400" data-id="element-276">
                $100
              </span>
            </div>

            <div className="text-center bg-purple-900/30 rounded-2xl p-6 md:p-8 border border-purple-500/30 relative overflow-hidden" data-id="element-277">
              <motion.div className="absolute top-0 left-0 w-full bg-yellow-500/10 border-b border-yellow-500/20 py-1.5 text-xs md:text-sm font-medium text-yellow-400 flex items-center justify-center gap-1.5" animate={{
              opacity: [0.8, 1, 0.8]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-278">
                <Zap className="w-3.5 h-3.5" data-id="element-279" />⚡ Solo quedan 23 copias a este
                precio
              </motion.div>

              <div className="mt-6 md:mt-8" data-id="element-280">
                <p className="text-purple-300 font-medium mb-2 uppercase tracking-wider text-xs md:text-sm" data-id="element-281">
                  Precio por tiempo limitado
                </p>
                <div className="flex flex-col items-center justify-center gap-1 mb-4 md:mb-6" data-id="element-282">
                  <span className="text-xs md:text-sm text-slate-400" data-id="element-283">
                    Esta oferta expira en:
                  </span>
                  <CountdownTimer className="text-xl md:text-2xl" data-id="element-284" />
                </div>
                <div className="flex items-center justify-center gap-3 md:gap-4 mb-6 md:mb-8" data-id="element-285">
                  <span className="text-2xl md:text-3xl text-slate-400 line-through" data-id="element-286">
                    $100
                  </span>
                  <span className="text-5xl md:text-7xl font-bold text-white" data-id="element-287">
                    $6.36
                  </span>
                </div>

                <Button href="https://www.viventispace.com/cart/46127430566076:1" className="w-full md:w-auto text-lg md:text-xl px-8 md:px-12 py-4 md:py-5 mb-6" data-id="element-288">
                  🟣 SÍ, QUIERO DORMIR PROFUNDO ESTA SEMANA →
                </Button>

                <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-xs md:text-sm text-slate-400" data-id="element-289">
                  <div className="flex items-center" data-id="element-290">
                    <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1" data-id="element-291" /> Pago
                    seguro
                  </div>
                  <div className="flex items-center" data-id="element-292">
                    <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1" data-id="element-293" /> Acceso
                    inmediato
                  </div>
                  <div className="flex items-center" data-id="element-294">
                    <Download className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1" data-id="element-295" />{' '}
                    Descarga en PDF
                  </div>
                  <div className="flex items-center" data-id="element-296">
                    <ShieldCheck className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1" data-id="element-297" />{' '}
                    Garantía 7 días
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}